export const data = [
    {
      "id": 1,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005693.jpeg",
      "name": "Still Life with Watermelon, 1953",
      "description": "Frida Kahlo's painting 'Still Life with Watermelon' from 1953 reflects her unique perspective and colorful style. This artwork is filled with symbols representing Mexican culture and elements of nature that Kahlo often used in her paintings."
    },
    {
      "id": 2,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005688.jpeg",
      "name": "Cityscape, 1925",
      "description": "Frida Kahlo's painting 'Cityscape' from 1925 is an impressive example of contemporary art. Kahlo portrays the complexity and beauty of city life using an unusual perspective in this artwork."
    },
    {
      "id": 3,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005165.jpeg",
      "name": "Self-Portrait with Thorn Necklace and Hummingbird",
      "description": "Frida Kahlo's self-portrait with a thorn necklace and hummingbird is an impressive artwork that reflects the artist's pains and inner world. Kahlo expresses her identity and emotions using symbols that she often used in her self-portraits."
    },
    {
      "id": 4,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005169.jpeg",
      "name": "Thinking About Death",
      "description": "Frida Kahlo's painting 'Thinking About Death' is inspired by the idea that death is a natural part of life. In this artwork, Kahlo expresses the complex emotions that arise when contemplating death and emphasizes that death is a natural process."
    },
    {
      "id": 5,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005679.jpeg",
      "name": "Little Girl with Death Mask",
      "description": "Frida Kahlo's painting 'Little Girl with Death Mask' takes a childlike approach to the theme of death. In this artwork, Kahlo depicts death as a child hiding behind a mask, symbolically representing the process of confronting death."
    },
    {
      "id": 6,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005141.jpeg",
      "name": "Self-Portrait with Curly Hair",
      "description": "Frida Kahlo's self-portrait with curly hair reflects the artist's unique style and personal identity. In her self-portraits, Kahlo often portrays herself in different styles, expressing her inner world."
    },
    {
      "id": 7,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005142.jpeg",
      "name": "Self-Portrait Dedicated to Dr. Eloesser",
      "description": "Frida Kahlo's painting 'Self-Portrait Dedicated to Dr. Eloesser' is dedicated to Kahlo's close friend, Dr. Eloesser. In this artwork, Kahlo presents a symbolic expression of friendship and gratitude."
    },
    {
      "id": 8,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005137.jpeg",
      "name": "Self-Portrait in Velvet Dress",
      "description": "Frida Kahlo's self-portrait in a velvet dress reflects the artist's feminine style and strong personality. Kahlo often portrays her clothing and accessories in a striking manner in her self-portraits."
    },
    {
      "id": 9,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0007689.jpeg",
      "name": "Self-Portrait on the Borderline Between Mexico and the United States",
      "description": "Frida Kahlo's painting 'Self-Portrait on the Borderline Between Mexico and the United States' reflects on the artist's roots and identity. In this artwork, Kahlo depicts the complexity of borders and identities."
    },
    {
      "id": 10,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005134.jpeg",
      "name": "Self-Portrait with Loose Hair, 1947",
      "description": "Frida Kahlo's self-portrait with loose hair from 1947 reflects the artist's quest for freedom and independence. In this artwork, Kahlo portrays herself as a free spirit, symbolically expressing her inner strength."
    },
    {
      "id": 11,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005122.jpeg",
      "name": "Mask, 1945",
      "description": "Frida Kahlo's painting 'Mask' explores the relationship between identity and masks. In this artwork, Kahlo examines how people hide their true identities behind masks and conceal their real selves."
    },
    {
      "id": 12,
      "imageUrl": "https://www.pivada.com/content/images/thumbs/000/0005100.jpeg",
      "name": "Self-Portrait with Portrait of Dr. Farill",
      "description": "Frida Kahlo's painting 'Self-Portrait with Portrait of Dr. Farill' showcases both a portrait and a self-portrait. The artist includes her own portrait while creating a portrait of Dr. Farill. This artwork demonstrates Kahlo's unique style and the deep meaning behind her portraits."
    }
  ]
  
  
  